import {
  Root,
  Form,
  FieldsContainer,
  Actions,
  ActionsLeft,
  ActionsRight,
  DeleteButton,
  EditButton,
  CancelButton,
  SubmitButton,
  AutosaveIndicator,
  AiScribe,
  AiScribeButton
} from './components';
import {
  NoteType,
  DateOfEncounter,
  StartTime,
  TimeSpent,
  NextContact,
  WhoDidYouReach,
  TypeOfSupport,
  Note,
  DocumentationTime
} from './fields';
import Manager from './fields/manager/manager';
import Chw from './fields/chw/chw';
import Provider from './fields/provider/provider';

// Create Fields namespace
const Fields = {
  AiScribe,
  NoteType,
  DateOfEncounter,
  StartTime,
  TimeSpent,
  NextContact,
  WhoDidYouReach,
  TypeOfSupport,
  Note,
  DocumentationTime,
  Manager,
  Chw,
  Provider
};

/**
 * NoteForm compound component for composable note editing.
 * Preset providers own Formik, autosave, and note actions.
 * Root is only the shared visual frame for composed fields/actions.
 *
 * @example
 * <DraftNoteFormProvider clientId={clientId} note={note}>
 *   <NoteForm.Root>
 *   <NoteForm.Form>
 *     ...fields
 *   </NoteForm.Form>
 * </NoteForm.Root>
 * </DraftNoteFormProvider>
 */
export const NoteForm = {
  Root,
  Form,
  FieldsContainer,
  Fields,
  Actions,
  DeleteButton,
  EditButton,
  CancelButton,
  SubmitButton,
  AutosaveIndicator,
  AiScribe,
  AiScribeButton
};

// Also export individual components for tree-shaking
export {
  Root,
  Form,
  FieldsContainer,
  Fields,
  Actions,
  ActionsLeft,
  ActionsRight,
  DeleteButton,
  EditButton,
  CancelButton,
  SubmitButton,
  AutosaveIndicator,
  AiScribe
};

// Export context hooks for advanced usage
export { useNoteFormContext, useAutosaveContext } from './context';

// Export hooks
export { useIsTranscribing } from './hooks';

// Export utils
export { createDefaultValues, remapValues, type NoteFormValues } from './utils';

// Export presets
